import { render, staticRenderFns } from "./CarouselVirtualSlides.vue?vue&type=template&id=2bf1dc6a&scoped=true&"
import script from "./CarouselVirtualSlides.vue?vue&type=script&lang=js&"
export * from "./CarouselVirtualSlides.vue?vue&type=script&lang=js&"
import style0 from "./CarouselVirtualSlides.vue?vue&type=style&index=0&id=2bf1dc6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1dc6a",
  null
  
)

export default component.exports